import React, { Component } from "react";
import { connect } from "react-redux";

class MessageFlightsBar extends Component {
	constructor() {
		super();
		this.alert = false;
	}

	renderErrorBar(airline) {
		return (
			<div className="alert alert-info" role="alert" key={airline.label}>
				<div className="alert--icon">
					<i className="icon-exclamation" />
				</div>
				<div className="alert--message" role="alert">
					<p>{airline.status.message}</p>
				</div>
			</div>
		);
	}

	verifyExistErro() {
		if (!this.props.searchStatus) return null;

		const { airlines, airlinesDisabled } = this.props.searchStatus;

		if (airlines === undefined) return null;

		const allAirlines = airlines.concat(airlinesDisabled);

		return allAirlines.filter(airline => {
			return airline.status.message != "";
		});
	}

	render() {
		let airlines = this.verifyExistErro();

		if (airlines && airlines.length > 0) {
			return <span> {airlines.map(this.renderErrorBar)}</span>;
		}

		return null;
	}
}

const mapStateToProps = state => ({
	searchStatus: state.searchStatus
});

export default connect(mapStateToProps)(MessageFlightsBar);
